import { useTranslation } from "react-i18next";
import defaultContent from "../../../content/profile";
import LeafDateTime from "../../../common/leaf/LeafDateTime/LeafDateTime";
import LeafPinLevelName from "../../../common/leaf/LeafPinLevelName/LeafPinLevelName";
import "./PinInfo.scss";

type Props = {
  title: string;
  pinLevelCode: number;
  date?: string;
  show?: boolean;
};

const PinInfo = (props: Props) => {
  const { title, pinLevelCode, date, show = true } = props;
  const { t } = useTranslation(["profile"]);

  if (!show || pinLevelCode <= 0) return null;

  return (
    <div className="pin-info">
      <div className="pin-info__title">
        {String(t(`aboProfile.overviewTab.${title}`, defaultContent["aboProfile"]["overviewTab"][title]))}
      </div>
      <div className="pin-info__content">
        <LeafPinLevelName pinLevelCode={pinLevelCode} />
        {date && (
          <div className="pin-info__date">
            <LeafDateTime date={date} options={{ month: "short", year: "numeric" }} />
          </div>
        )}
      </div>
    </div>
  );
};

export default PinInfo;
